!function() {
    "use strict";
    customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
        constructor() {
            var t, e, i;
            super(),
            i = t=>{
                const e = t ? "add" : "remove";
                this.form.closest(".product-form").classList[e]("adding")
            }
            ,
            (e = "toggleSpinner")in (t = this) ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = i,
            this.selectors = {
                form: "form",
                inputId: "[name=id]",
                submitButton: '[name="add"]',
                errorWrapper: ".prod__form-error",
                customFields: ["[data-product-custom-field]"],
                dynamicCheckout: ".prod__dynamic_checkout"
            },
            this.domNodes = queryDomNodes(this.selectors, this),
            this.form = this.domNodes.form,
            this.submitButton = this.domNodes.submitButton,
            this.domNodes.inputId.disabled = !1,
            this.Notification = window.MinimogTheme.Notification,
            this.notificationType = this.dataset.notificationType,
            this.customFields = document.querySelectorAll(this.selectors.customFields),
            this.domNodes.dynamicCheckout && (this.enable_dynamic_checkout = !0),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            this.domNodes.dynamicCheckout && this.customFields && this.domNodes.dynamicCheckout.addEventListener("click", (t=>{
                validateForm(this.form.closest(".main-product__blocks")).length > 0 && (t.stopPropagation(),
                this.Notification.show({
                    target: this.domNodes.errorWrapper,
                    method: "appendChild",
                    type: "warning",
                    message: window.MinimogStrings.requiredField,
                    delay: 100
                }))
            }
            ), !0)
        }
      async  onSubmitHandler(t) {
            t.preventDefault(),
            this.toggleSpinner(!0);
            if (validateForm(this.form.closest(".main-product__blocks"))?.length > 0)
                return this.toggleSpinner(!1),
                this.Notification.show({
                    target: this?.domNodes?.errorWrapper,
                    method: "appendChild",
                    type: "warning",
                    message: window.MinimogStrings.requiredField
                });
            const e = {
                method: "POST",
                headers: {
                    Accept: "application/javascript",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
              , i = new FormData(this.form);
          if(window.opts){
            var color_selector = $(
              opts.textColorWrapper + " .customizer__values input:checked"
            );
              let stickerPosition = $('.sticker-image-container.selected').attr('position')
            let magsafeWalletSticker = $('.magsafe-wallet.sticker-image-container.selected').attr('sticker')
            if(magsafeWalletSticker && magsafeWalletSticker !== 'undefined'){
              i.set("properties[sticker]",magsafeWalletSticker); 
            }
            else if(stickerPosition && stickerPosition !== 'undefined'){
               i.set("properties[StickerPostion]",stickerPosition); 
            }else{
              if($(opts.inputField).val()){
                i.set("properties[text]",$(opts.inputField).val()); 
                if(opts.getSelectedFontFamily()){
                  i.set("properties[FontFamily]",opts.getSelectedFontFamily()); 
                }  
                if(opts.getSelectedTextPosition()){
                  i.set("properties[FontPosition]",opts.getSelectedTextPosition()); 
                }
                if(opts.getSelectedFontFamily() == 'customFont'){
                  i.set("properties[FontColor]",opts.getSelected3DTextColor()); 
                }  
                else if(color_selector){
                  if(color_selector.val()){
                     i.set("properties[FontColor]",color_selector.val()); 
                  }
                }
            }
            // let toonzeSticker = $('.toonz-stickers .sticker-image-container.selected').attr('sticker')
            //  if(stickerPosition && stickerPosition !== 'undefined'){
            //    i.set("properties[Sticker]",stickerPosition); 
            // }

                if($(opts.alphabetInputField).val()){
                i.set("properties[toonz text]",$(opts.alphabetInputField).val()); 
                if(opts.getSelectedFontFamily()){
                  i.set("properties[FontFamily]",'Toonz Alphabet'); 
                }  
                if(opts.getSelectedTextPosition()){
                  i.set("properties[FontPosition]",opts.getSelectedToonzAlphabetPosition()); 
                }
                // if(opts.getSelectedFontFamily() == 'customFont'){
                //   i.set("properties[FontColor]",opts.getSelected3DTextColor()); 
                // }  
                // else if(color_selector){
                //   if(color_selector.val()){
                //      i.set("properties[FontColor]",color_selector.val()); 
                //   }
                // }
            }
            }
        //   i.set("properties[_img_src]",window.opts.canvasInstance.toDataURL()); 
           let body = new FormData();
            console.log("body",window.opts.canvasInstance.toDataURL().replace("data:image/png;base64,",""))
           body.append('image', window.opts.canvasInstance.toDataURL().replace("data:image/png;base64,",""))  
           // const rawResponse = await fetch('https://api.imgbb.com/1/upload?key=278467e285979e460496f8544ac5dba7', {
           //   method: 'POST',
           //   body: body
           // });
            const rawResponse = await fetch('http://lanej.codecrewinfotech.com/index.php', {
             method: 'POST',
             body: body 
           });
         const content = await rawResponse.json();
            console.log("content.data.image.url",content.data.image.url)
            i.set("properties[_img_src]",content.data.image.url); 
          }
            e.body = i;
            const {MinimogSettings: o, MinimogStrings: s} = window;
            o.use_ajax_atc ? fetch(`${o.routes.cart_add_url}`, e).then((t=>t.json())).then((t=>{
                if (t.status)
                    return this.Notification.show({
                        target: "toast" === this.notificationType ? document.body : this.domNodes.errorWrapper,
                        method: "appendChild",
                        type: "warning",
                        message: t.description,
                        last: 3e3,
                        sticky: "toast" === this.notificationType
                    });
                o.enable_cart_drawer || this.Notification.show({
                    target: this.domNodes.errorWrapper,
                    method: "appendChild",
                    type: "success",
                    message: window.MinimogStrings.itemAdded,
                    last: 3e3,
                    sticky: "toast" === this.notificationType
                }),
                window.MinimogEvents.emit("ON_ITEM_ADDED", t),
                window.Shopify.onItemAdded(t)
            }
            )).catch((t=>{}
            )).finally((()=>{
                this.toggleSpinner(!1)
            }
            )) : this.form.submit()
        }
    }
    )
}();
